import React from 'react';

import { IIconProps, TIconType } from '../interface';

const AssetsIcon: TIconType = (props?: IIconProps) => {
	return (
		props?.isActive ? (
			<svg
				fill='none'
				height='24'
				viewBox='0 0 24 24'
				width='24'
				{...props?.innerSvgProps}
			>
				<path
					d='M22.5 19.5H21.75V9.75C21.75 9.35218 21.592 8.97064 21.3107 8.68934C21.0294 8.40804 20.6478 8.25 20.25 8.25H14.25V3.75C14.25 3.35218 14.092 2.97064 13.8107 2.68934C13.5294 2.40804 13.1478 2.25 12.75 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V19.5H1.5C1.30109 19.5 1.11032 19.579 0.96967 19.7197C0.829018 19.8603 0.75 20.0511 0.75 20.25C0.75 20.4489 0.829018 20.6397 0.96967 20.7803C1.11032 20.921 1.30109 21 1.5 21H22.5C22.6989 21 22.8897 20.921 23.0303 20.7803C23.171 20.6397 23.25 20.4489 23.25 20.25C23.25 20.0511 23.171 19.8603 23.0303 19.7197C22.8897 19.579 22.6989 19.5 22.5 19.5ZM11.25 12.75C11.25 12.9489 11.171 13.1397 11.0303 13.2803C10.8897 13.421 10.6989 13.5 10.5 13.5H7.5C7.30109 13.5 7.11032 13.421 6.96967 13.2803C6.82902 13.1397 6.75 12.9489 6.75 12.75C6.75 12.5511 6.82902 12.3603 6.96967 12.2197C7.11032 12.079 7.30109 12 7.5 12H10.5C10.6989 12 10.8897 12.079 11.0303 12.2197C11.171 12.3603 11.25 12.5511 11.25 12.75ZM6 6H9C9.19891 6 9.38968 6.07902 9.53033 6.21967C9.67098 6.36032 9.75 6.55109 9.75 6.75C9.75 6.94891 9.67098 7.13968 9.53033 7.28033C9.38968 7.42098 9.19891 7.5 9 7.5H6C5.80109 7.5 5.61032 7.42098 5.46967 7.28033C5.32902 7.13968 5.25 6.94891 5.25 6.75C5.25 6.55109 5.32902 6.36032 5.46967 6.21967C5.61032 6.07902 5.80109 6 6 6ZM6 15.75H9C9.19891 15.75 9.38968 15.829 9.53033 15.9697C9.67098 16.1103 9.75 16.3011 9.75 16.5C9.75 16.6989 9.67098 16.8897 9.53033 17.0303C9.38968 17.171 9.19891 17.25 9 17.25H6C5.80109 17.25 5.61032 17.171 5.46967 17.0303C5.32902 16.8897 5.25 16.6989 5.25 16.5C5.25 16.3011 5.32902 16.1103 5.46967 15.9697C5.61032 15.829 5.80109 15.75 6 15.75ZM14.25 9.75H20.25V19.5H14.25V9.75Z'
					fill='#2E2E6B'
				/>
				<path
					d='M18 15.75H16.5C16.3011 15.75 16.1103 15.829 15.9697 15.9697C15.829 16.1103 15.75 16.3011 15.75 16.5C15.75 16.6989 15.829 16.8897 15.9697 17.0303C16.1103 17.171 16.3011 17.25 16.5 17.25H18C18.1989 17.25 18.3897 17.171 18.5303 17.0303C18.671 16.8897 18.75 16.6989 18.75 16.5C18.75 16.3011 18.671 16.1103 18.5303 15.9697C18.3897 15.829 18.1989 15.75 18 15.75Z'
					fill='#2E2E6B'
				/>
				<path
					d='M18 13.125H16.5C16.4005 13.125 16.3052 13.0855 16.2348 13.0152C16.1645 12.9448 16.125 12.8495 16.125 12.75C16.125 12.6505 16.1645 12.5552 16.2348 12.4848C16.3052 12.4145 16.4005 12.375 16.5 12.375H18C18.0995 12.375 18.1948 12.4145 18.2652 12.4848C18.3355 12.5552 18.375 12.6505 18.375 12.75C18.375 12.8495 18.3355 12.9448 18.2652 13.0152C18.1948 13.0855 18.0995 13.125 18 13.125Z'
					fill='#2E2E6B'
					stroke='#2E2E6B'
					strokeWidth='0.75'
				/>
			</svg>
		) : (
			<svg
				fill='none'
				height='24'
				viewBox='0 0 24 24'
				width='24'
				{...props?.innerSvgProps}
			>
				<path
					d='M1.5 20.25H22.5'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M13.5 20.25V3.75C13.5 3.55109 13.421 3.36032 13.2803 3.21967C13.1397 3.07902 12.9489 3 12.75 3H3.75C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V20.25'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M21 20.25V9.75C21 9.55109 20.921 9.36032 20.7803 9.21967C20.6397 9.07902 20.4489 9 20.25 9H13.5'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M6 6.75H9'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M7.5 12.75H10.5'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M6 16.5H9'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M16.5 16.5H18'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M16.5 12.75H18'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		)
	);
};

export default AssetsIcon;
